import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        if: [
          [
            {
              '!=': [
                {
                  '@': 'editingSubrecipient',
                },
                null,
              ],
            },
            'Edit Subrecipient',
          ],
          'Create New Subrecipient',
        ],
      },
      type: 'details',
      content: {
        '{}': {
          fields: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubrecipient',
                      },
                      'code',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!subrecips#!subrecip:!code',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubrecipient',
                      },
                      'name',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!subrecips#!subrecip:!name',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'descr',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubrecipient',
                      },
                      'descr',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId: 'attr:ent#!subrecips#!subrecip:!descr',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'website',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubrecipient',
                      },
                      'website',
                    ],
                  },
                  meta: {
                    '{}': {
                      direct: {
                        '{}': {
                          name: 'Website',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'primaryContact',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubrecipient',
                      },
                      'primaryContact',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subrecips#!subrecip:!primary_contact',
                        },
                      },
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'institution',
                  value: {
                    '@>': [
                      {
                        '@': 'editingSubrecipient',
                      },
                      'institution',
                    ],
                  },
                  meta: {
                    '{}': {
                      dmsAttr: {
                        '{}': {
                          attributeId:
                            'attr:ent#!subrecips#!subrecip:!institution',
                        },
                      },
                    },
                  },
                },
              },
            ],
          },
          onSave: {
            '{}': {
              action: {
                '{}': {
                  alias: 'sr.save-subrecipient',
                },
              },
              variables: {
                '{}': {
                  subrecipientId: {
                    '@$': 'subrecipientId',
                  },
                  subrecipientCode: '${field:code}',
                  subrecipientName: '${field:name}',
                  subrecipientDescr: '${field:descr}',
                  subrecipientWebsite: '${field:website}',
                  subrecipientInstitution: '${field:institution}',
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    editingSubrecipient: {
      selection: {
        '{}': {
          code: {
            '@.': '!code',
          },
          name: {
            '@.': '!name',
          },
          descr: {
            '@.': '!descr',
          },
          website: {
            '@.': '!website',
          },
          primaryContact: {
            '@.': '!primary_contact',
          },
          institution: {
            '@.': '!institution',
          },
        },
      },
      target: 'ent:!subrecips:!subrecip',
      quantity: 1,
      filter: {
        '=': [
          {
            '@.': '!id',
          },
          {
            '@$': 'subrecipientId',
          },
        ],
      },
    },
  },
}
